import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../Form/FormField";
import FormDate from "../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import {withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../Form/utils";
import FormCheck from "../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../Form/DeleteButton";
import FormSelect from "../Form/FormSelect";

class AccountFormFields extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false
        };
    }

    render() {
        const {
            person,
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            isEdit
        } = this.props;

        return (
            <form
                method="POST"
                url={formUrl}
                onSubmit={handleSubmit}
            >
                <input type="hidden" name="id_person" value={values.id_person} onChange={handleChange}/>

                <Grid container spacing={24}>
                    <Grid item xs={12}>
                        <FormField
                            type="text"
                            name="iban"
                            label={i18n.get('accounts.iban')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.iban}
                            error={errors.iban}
                            touched={touched.iban}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            type="text"
                            name="bic"
                            label={i18n.get('accounts.bic')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.bic}
                            error={errors.bic}
                            touched={touched.bic}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormField
                            type="text"
                            name="bank"
                            label={i18n.get('accounts.bank')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.bank}
                            error={errors.bank}
                            touched={touched.bank}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={24} justify="space-between" alignItems="center" style={{paddingTop: 8}}>
                    <Grid item>
                        {isEdit && (
                            <DeleteButton
                                href={`/accounts/${values.id}`}
                                confirmMessage={i18n.get('accounts.confirm_message')}
                                successMessage={i18n.get('accounts.delete_success_message')}
                                handleSuccess={() => {history.go(-1)}}
                            />
                        )}
                    </Grid>
                    <Grid item>
                        <Button size="small"
                                variant="contained"
                                color="primary"
                                type="submit"
                        >
                            {isEdit ?
                                (<Icon fontSize="small">refresh</Icon>) :
                                (<Icon fontSize="small">save</Icon>)
                            } &nbsp;
                            {isEdit ? i18n.get('accounts.update') : i18n.get('accounts.save')}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        )
    }
}

export default AccountFormFields



// WEBPACK FOOTER //
// ./resources/assets/js/components/Accounts/AccountFormFields.js